import React, { useEffect } from 'react';
import { Col, Container, Row } from 'shards-react';
import PageTitle from '../components/common/PageTitle';
import Notification from '../components/common/Notification';
import SelectOrganization from '../components/manage-user/SelectOrganization';
import AddUser from '../components/manage-user/AddUser';
import GridUser from '../components/manage-user/GridUser';
import ModalEditUser from '../components/manage-user/ModalEditUser';
import { useTranslation } from 'react-i18next';
import useUserRoles from '../hooks/useUserRoles';
import { RootState, useDispatch, useSelector } from '../redux/store';
import { resetMessage } from '../redux/slices/user';
import { getOrganizations } from '../redux/slices/organization';
import { getSteelMakerOptions, getBusinessTypeOptions, getSteelCategoryOptions, getTradingCompanyOptions, getOrganizationBaseOptions } from '../redux/slices/options';

const ManageUser = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { hasError, serverMessage } = useSelector((state: RootState) => state.user);
  const { isMaintenanceadmin } = useUserRoles();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  /**
   * 初期データの取得
   */
  useEffect(() => {
    dispatch(getTradingCompanyOptions());
    dispatch(getSteelMakerOptions());
    dispatch(getBusinessTypeOptions());
    dispatch(getSteelCategoryOptions());
    dispatch(getOrganizations());
    dispatch(getOrganizationBaseOptions());
    // 組織選択パーツで呼び出すのでここではgetUsersしない
    // dispatch(getUsers({}));
  }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * クローズボタンを押したとき
   */
  const dismiss = (): void => {
    dispatch(resetMessage());
  };

  // VIEW
  // ================================================================================

  return (
    <Container fluid className="main-content-container px-4">
      <Row id="pageTitle" noGutters className="page-header py-4">
        <PageTitle sm="4" title={t('user.manage')} subtitle="Manage User" className="text-sm-left" />
      </Row>

      <Notification theme={hasError ? 'danger' : 'success'} isOpen={serverMessage !== undefined && serverMessage.length > 0} message={serverMessage} dismissCallback={dismiss} />

      <Row className="mb-4">
        <Col md="3" sm="6">
          <SelectOrganization />
        </Col>
        <Col md="3" sm="6">
          {isMaintenanceadmin && <AddUser />}
        </Col>
      </Row>

      <GridUser />
      <ModalEditUser />
    </Container>
  );
};

export default ManageUser;
